import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import { Button, Collapse, Row } from 'reactstrap'

interface IAdvancedSearchProps {
  children: React.ReactNode
  className?: string
  expand?: 'sm' | 'md' | 'lg' | 'xl'
  style?: React.CSSProperties
}

interface IAdvancedSearchState {
  isOpen: boolean
}

export default class AdvancedSearch extends React.PureComponent<
  IAdvancedSearchProps,
  IAdvancedSearchState
> {
  constructor(props: IAdvancedSearchProps) {
    super(props)

    this.state = {
      isOpen: false,
    }

    bindFunctions(this)
  }

  public render() {
    const toggleContainerClasses = classNames('clearfix mb-1', {
      [`d-${this.props.expand}-none`]: this.props.expand !== undefined,
    })

    const collapseClasses = classNames({
      [`d-${this.props.expand}-block`]: this.props.expand !== undefined,
    })

    return (
      <div className={this.props.className} style={this.props.style}>
        <div className={toggleContainerClasses}>
          <Button
            className='float-right'
            color='link'
            onClick={this._toggle}
            size='sm'
          >
            Advanced search{' '}
            <FontAwesomeIcon icon={['fas', 'caret-down']} fixedWidth />
          </Button>
        </div>
        <Collapse className={collapseClasses} isOpen={this.state.isOpen}>
          <Row>{this.props.children}</Row>
        </Collapse>
      </div>
    )
  }

  private _toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
}
